export default __webpack_public_path__ + "static/squaw-USA-a42b9c6a2cf6d313205139a314eb16c1.jpg";